var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"language-switcher"},[_c('button',{attrs:{"disabled":_vm.isDisabled('ru'),"value":"ru"},on:{"click":_vm.change}},[_vm._v("RU")]),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.isDisabled('en'),"value":"en"},on:{"click":_vm.change}},[_vm._v("EN")])])
}
var staticRenderFns = []

export { render, staticRenderFns }